import React from 'react';
import { Navigate, useParams, useLocation } from 'react-router-dom';

const LegacyTenantRedirect = () => {
  const { token } = useParams<{ token: string }>();
  const location = useLocation();

  // Extract the route type and redirect to the appropriate tenant portal path
  if (location.pathname.includes('/tenant-signup/') && token) {
    return <Navigate to={`/tenant-portal/signup/${token}`} replace />;
  }
  
  if (location.pathname.includes('/tenant-onboarding/') && token) {
    return <Navigate to={`/tenant-portal/onboarding/${token}`} replace />;
  }
  
  if (location.pathname.includes('/tenant-signing/') && token) {
    return <Navigate to={`/tenant-portal/signing/${token}`} replace />;
  }
  
  if (location.pathname === '/tenant-dashboard') {
    return <Navigate to="/tenant-portal/dashboard" replace />;
  }

  // Fallback to tenant portal login
  return <Navigate to="/tenant-portal/login" replace />;
};

export default LegacyTenantRedirect;